module.exports = __webpack_public_path__ + "static/media/noti-bg3.b33bc400.jpg";